import { combineReducers } from 'redux'

import P from 'helpers/predicates'
import {
  UPDATE_REDIRECT,
} from './constants'
import {
  createReducer,
} from 'helpers/ReducerUtil'

const updateRedirect = (prev, { redirect }) => P.isNotNil(redirect)
  ? redirect
  : prev

const redirectSliceReducer = createReducer(false, {
  [UPDATE_REDIRECT]: updateRedirect,
})

const projectUpdateReducer = combineReducers({
  redirect: redirectSliceReducer
})

export {
  projectUpdateReducer
}
